import { InputNumber } from 'primereact/inputnumber'
import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1rem;
`

export const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center;
`

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`

export const Label = styled.span`
    font-weight: bold;
    color: #444;
`

export const ColoredLabel = styled.span`
    margin-left: 0.5rem;
    font-weight: bold;
`

export const TelitettsegIcon = styled.img`
    font-weight: bold;
    color: #444;
`

export const Highlight = styled.span`
    font-weight: bold;
    color: #ba9d31;
`

export const PriceText = styled.div`
    font-size: 1.1rem;
`

export const StyledInputNumber = styled(InputNumber)`
    .p-button {
        background-color: #ba9d31;
        border-color: #ba9d31;
    }

    .p-button:disabled {
        opacity: 0.5;
    }
`
